import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { NgZone, inject } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * `withFetch()` completes outside a CD-scheduled turn.
 * Always `ngZone.run()` so the view refreshes after HTTP, like Zone-patched XHR in v15.
 */
export const zoneHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const ngZone = inject(NgZone);

  return new Observable<HttpEvent<unknown>>((subscriber) => {
    const subscription = next(req).subscribe({
      next: (event) => ngZone.run(() => subscriber.next(event)),
      error: (err) => ngZone.run(() => subscriber.error(err)),
      complete: () => ngZone.run(() => subscriber.complete())
    });
    return () => subscription.unsubscribe();
  });
};
